// extracted by mini-css-extract-plugin
module.exports = {"module3":"module3_module3__nWNja","module3Container":"module3_module3Container__xw1d2"};